import { NFCState } from './state';
import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import { mutations } from '@/modules/Administrative/store/mutations';
import { actions } from '@/modules/Administrative/store/actions';
import { getters } from '@/modules/Administrative/store/getters';
import { state } from '@/modules/Administrative/store/state';

const module: Module<NFCState, RootState> = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};

export default module;
export type {NFCState};
